import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

export interface RegisterContextType {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

export default function RegisterLayout() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  return (
    <Outlet context={{ formData, setFormData } satisfies RegisterContextType} />
  );
}
